<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="图片" prop="imageUrl">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：256px * 256px</span>
        </el-form-item>
        <el-form-item label="视频" prop="videoUrl">
          <el-upload
            accept=".mp4,.m3u8"
            :action="QNUploadURL"
            :data="uploadToken"
            :before-upload="beforeUpload"
            :file-list="form.videoUrl"
            :on-success="video_success"
            :on-remove="video_remove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          <template v-slot:tip ><div class="el-upload__tip">只能上传MP4/M3U8文件</div></template>
          </el-upload>
        </el-form-item>
        <el-form-item label="物件ID" prop="itemId">
          <el-select
            v-model="form.itemId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词搜索"
            :remote-method="remoteMethod"
            :loading="loading"
            class="fix-width"
          >
            <el-option
              v-for="item in itemList"
              :key="item.itemId"
              :label="item.title"
              :value="item.itemId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <tinymce-editor
            :height="460"
            :value="form.text"
            @inputChange="inputChange"
          ></tinymce-editor>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createMedium, updateMedium, findItemAll,findItem } from '@/api/mediaLibrary'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'

export default {
  name: 'MediaMediumEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      loading:false,
      itemList:[],
      form: {
        mediumId: '',
        itemId: '',
        imageUrl: '',
        videoUrl: [],
        text: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        itemId: [{ required: true, trigger: 'blur', message: '请选择物件' }],
        // imageUrl: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (value.length == 0) {
        //         callback(new Error('请上传图片'))
        //       } else {
        //         callback()
        //       }
        //     },
        //   },
        // ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改媒体'
        this.form = Object.assign(this.form, row.basic)
        this.form.mediumId = row.mediumId
        const itemId = row.basic.itemId
        const res = await findItem({itemId})
        this.itemList = res?[res]:[]
      } else {
        this.title = '新增媒体'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    async remoteMethod(keyword) {
      if(keyword !== '') {
        this.loading = true
        const res = await findItemAll({keyword})
        this.loading = false
        this.itemList  = res || []
      }else {
        this.itemList = []
      }
    },
    beforeUpload(file) {
      const isMP4 = file.type === 'video/mp4';
      const isM3U8 = file.type === 'video/m3u8';

      if (!isMP4 && !isM3U8) {
        this.$message.error('上传视频只能是 MP4 或 M3U8 格式!');
      }

      const result = isMP4 || isM3U8;
      return result;
    },
    video_remove(file, fileList) {
      this.form.videoUrl = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    video_success(res, file) {
      if (!res.hash) {
        this.$message.error('视频上传失败')
        return
      }
      this.form.videoUrl.push({
        name: file.name,
        url: `${QNHost}/${res.hash}`
      })
    },
    // 图片
    image_remove(file, fileList) {
      this.form.imageUrl = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageUrl = `${QNHost}/${res.hash}`
    },
    inputChange(value) {
      this.form.text = value
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.itemList = []
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const mediumId = this.form.mediumId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${mediumId ? '修改' : '新增'}媒体吗`,
            null,
            async () => {
              mediumId ? await updateMedium(data) : await createMedium(data)
              this.$baseMessage(
                `${mediumId ? '修改' : '新增'}媒体成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
</style>
